import React from 'react';
import { CheckCircle2Icon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { MOCKUP_URL, packageItems } from '../../data/content';
export function Offer() {
  return <section id="offer" className="w-full bg-mist px-4 py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-261" data-mp="357f7222mevdm">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-[28px] bg-white shadow-[0_30px_60px_-30px_rgba(10,34,51,0.45)] ring-2 ring-gold-400" data-id="element-262" data-mp="3a4nn9x47kpc8">
        <div className="bg-navy-900 px-5 py-6 text-center text-white sm:px-8" data-id="element-263" data-mp="3jv8irbol5dqx">
          <p className="text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-264" data-mp="3jxcvmj4gpn3c">Your complete professional toolkit</p>
          <h2 id="offer-title" className="mt-2 font-display text-2xl font-black leading-tight sm:text-3xl" data-id="element-265" data-mp="3svyeyghrd656">
            Aesthetic Laser Complications Decision Blueprint™
          </h2>
        </div>

        <div className="px-4 pb-8 pt-6 sm:px-8" data-id="element-266" data-mp="1klgmuoak4klz">
          <img src={MOCKUP_URL} alt="Complete blueprint package" className="w-full" data-id="element-267" data-mp="1km9juxjprvqx" />

          <p className="mt-6 font-display text-sm font-black uppercase text-navy-900" data-id="element-268" data-mp="1flc2gn6j35qh">You receive:</p>
          <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-269" data-mp="1bltm84pnjitz">
            {packageItems.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink/85" data-id="element-270" data-mp="16n0eyu0yko29">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-271" data-mp="23aoctqdldjud" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-272" data-mp="1uiuovivqh6ur">
            <p className="text-sm font-bold uppercase tracking-wide text-ink/60" data-id="element-273" data-mp="1uhjnfpprgb6t">Complete package</p>
            <p className="mt-1 font-display text-7xl font-black leading-none text-navy-900 sm:text-8xl" data-id="element-274" data-mp="1pigqytnujdag">
              $27
              <span className="ml-1 align-top text-2xl font-extrabold text-ink/60" data-id="element-275" data-mp="2i98i3cq21bqx">USD</span>
            </p>
            <p className="mt-2 font-semibold text-accent-600" data-id="element-276" data-mp="315qu3s6klmz7">One-Time Payment. No Subscription.</p>
            <p className="mx-auto mt-3 flex max-w-sm items-start justify-center gap-2 rounded-xl bg-mist px-3 py-2 text-sm text-ink/75" data-id="element-277" data-mp="364ahzy4q58u7">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-600" aria-hidden="true" data-id="element-278" data-mp="2scdt02ycrf21" />
              Currency conversion is automatic — you'll see the price in your local currency at checkout.
            </p>
          </div>

          <div className="mt-7 flex flex-col items-center gap-6" data-id="element-279" data-mp="2ihc5tcnn0n23">
            <ScarcityBar data-id="element-280" data-mp="2nfnhzu1en9nh" />
            <CTAButton data-id="element-281" data-mp="2nbpukw7snvxs">Get my complete clinical blueprint</CTAButton>
            <CountdownTimer data-id="element-282" data-mp="29fvvt60qimye" />
            <p className="flex items-center gap-2 text-sm font-medium text-ink/70" data-id="element-283" data-mp="29gns6j25oopq">
              <ShieldCheckIcon className="h-5 w-5 text-accent-500" aria-hidden="true" data-id="element-284" data-mp="2dg6cpdq2exs1" />
              Protected by our 7-day money-back guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}